import React from 'react';
import useFbInsightsTracker from './widgets/FbInsightsTracker';
import useLinkedinPartner from './widgets/LinkedinPartner';
import WhatsAppWidget from './widgets/WhatsApp';
import useTawk from './widgets/Tawk';
import { guc } from '../Localisation';

const WidgetingService = ({ }) => {

    useLinkedinPartner();

    useFbInsightsTracker();
    
    useTawk();
    
    return <>
        {!guc('oyo_chat_enabled') && <WhatsAppWidget />}
    </>;

}

export default WidgetingService;
